var _path, _rect, _path2, _rect2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 2.49152V25.3305H24.9153V50.661H3.32203",
    stroke: "#ADADAD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 25.7458,
    width: 21.5932,
    height: 21.5932,
    fill: "#ADADAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20577 42.0517V27.6494H5.90108V44.7119H17.198V42.0517H9.20577Z",
    fill: "#161616"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0847,
    width: 21.5932,
    height: 21.5932,
    fill: "#ADADAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0733 13.5388H35.6162C36.5459 13.5388 37.3858 13.406 38.1358 13.1404C38.8858 12.8747 39.5264 12.5036 40.0576 12.0271C40.5811 11.5583 40.9834 10.9997 41.2647 10.3513C41.5537 9.70285 41.6983 8.99582 41.6983 8.23019C41.6983 7.40988 41.5537 6.66379 41.2647 5.99191C40.9834 5.32004 40.5811 4.74191 40.0576 4.25754C39.5264 3.78098 38.8858 3.40988 38.1358 3.14426C37.3858 2.87082 36.5459 2.7341 35.6162 2.7341H29.7803V19.7966H33.0733V13.5388ZM33.0733 10.8669V5.40598H35.6162C36.085 5.40598 36.4912 5.48019 36.835 5.62863C37.1787 5.77707 37.4678 5.98019 37.7022 6.23801C37.9287 6.49582 38.0967 6.7966 38.2061 7.14035C38.3233 7.4841 38.3819 7.85519 38.3819 8.25363C38.3819 8.59738 38.3233 8.92941 38.2061 9.24973C38.0967 9.56223 37.9287 9.83957 37.7022 10.0818C37.4678 10.3239 37.1787 10.5154 36.835 10.656C36.4912 10.7966 36.085 10.8669 35.6162 10.8669H33.0733Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1bf582a8fe00410a34e9d3ff325ceac5.svg";
export { ForwardRef as ReactComponent };